/**
 * Matches a help topic's route pattern against an address.
 *
 *   /learning               only /learning (a trailing slash is ignored)
 *   /event/:id              one segment of anything in place of :id
 *   /admin/recognition/*    /admin/recognition and anything under it
 */
function segments(path: string): string[] {
  return path.split('?')[0].split('#')[0].split('/').filter(Boolean);
}

export function matchRoute(pattern: string, pathname: string): boolean {
  const want = segments(pattern);
  const have = segments(pathname);
  for (let i = 0; i < want.length; i += 1) {
    const w = want[i];
    if (w === '*' && i === want.length - 1) return true;
    if (i >= have.length) return false;
    if (w.startsWith(':') || w === '*') continue;
    if (w !== have[i]) return false;
  }
  return want.length === have.length;
}

/** How specific a pattern is, so a topic for /admin/recognition/rules sorts above one for /admin/*. */
export function routeSpecificity(pattern: string): number {
  return segments(pattern).reduce((n, s) => n + (s === '*' ? 0 : s.startsWith(':') ? 1 : 2), 0);
}

/** The best match among a topic's routes for this address, or -1 when none matches. */
export function bestRouteScore(patterns: string[], pathname: string): number {
  return patterns.reduce((best, p) => (matchRoute(p, pathname) ? Math.max(best, routeSpecificity(p)) : best), -1);
}
